"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const info_card_1 = require("./info-card");
const PasswordSection = ({ editDetails }) => {
    const passwordSectionFields = [
        {
            label: 'Password',
            value: '*********',
        },
    ];
    return ((0, jsx_runtime_1.jsx)(info_card_1.default, { title: 'Password', infoFields: passwordSectionFields, editProps: editDetails }));
};
exports.PasswordSection = PasswordSection;
